import * as Sentry from "@sentry/react"

import { MonitoringReportAnnotations } from "types/MonitoringReportAnnotations"
const decodeCustomUrlParam = (param: string): MonitoringReportAnnotations | null => {
  try {
    const decodedParam = atob(param)
    const parsedParam = JSON.parse(decodedParam)

    return parsedParam
  } catch (error) {
    Sentry.captureException(error)

    return null
  }
}

export default decodeCustomUrlParam
